// Enter your Google recaptcha site key below

const key = '6LdcpN4ZAAAAAMQo9Qe6eyEmood103dT3lOcV9H9';
export default key;

